// Podtemat 4 - zadania zamkniete egzaminu osmoklasisty z dzialu VII (geometria analityczna).

import * as ParallelogramVertex from "../../temat1_punkty_odcinki/E8ParallelogramVertexClosedTask";
import * as MapDistancesPF from "../../temat1_punkty_odcinki/E8MapDistancesPFClosedTask";

export const registry = {
  E8ParallelogramVertexClosedTask: ParallelogramVertex,
  E8MapDistancesPFClosedTask: MapDistancesPF,
};

export function generateTasks(options = {}) {
  return [MapDistancesPF.generateTask(options), ParallelogramVertex.generateTask(options)];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 closed task type in geometria analityczna: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
